import PropTypes from 'prop-types';
import { graphql, useFragment } from 'react-relay';

// components
import { SbSharedRefineMenuMultiSelectList } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectList.jsx';

const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuFilterPeriod_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuMultiSelectList_itemSearch
    }
`;

export const SbSharedRefineMenuFilterPeriod = ({
    itemSearch: itemSearchRef,
    collapsedItemCount,
    filterName,
    shouldUseExpandableList,
    values,
    trackingOptions,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    return (
        <SbSharedRefineMenuMultiSelectList
            itemSearch={itemSearch}
            collapsedItemCount={collapsedItemCount}
            filterName={filterName}
            shouldUseExpandableList={shouldUseExpandableList}
            values={values}
            trackingOptions={trackingOptions}
        />
    );
};

SbSharedRefineMenuFilterPeriod.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    collapsedItemCount: PropTypes.number,
    filterName: PropTypes.string.isRequired,
    shouldUseExpandableList: PropTypes.bool,
    values: PropTypes.array.isRequired,
    trackingOptions: PropTypes.object,
};
